import { Link } from "react-router-dom";
import { Home, ArrowLeft } from "lucide-react";
import { Button } from "antd";
import ReportErrorButton from "Components/ReportErrorButton/ReportErrorButton";

const NotFound = () => {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4">
      <div className="max-w-md w-full text-center space-y-8">
        <div className="space-y-2">
          <p className="text-8xl font-extrabold ">
            404
          </p>
          <h1 className="text-2xl font-bold tracking-tight">Page not found</h1>
          <p className="text-muted-foreground text-sm leading-relaxed">
            Sorry, we couldn&apos;t find the page you&apos;re looking for. It might have
            been moved, deleted, or the URL may be incorrect.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Button icon={<Home className="h-4 w-4" />}>
            <Link to="/shoup-community/dashboard">Go to Dashboard</Link>
          </Button>
          <Button
            type="default"
            icon={<ArrowLeft className="h-4 w-4" />}
            onClick={() => window.history.back()}
          >
            Go Back
          </Button>
          <ReportErrorButton context="404 — Page Not Found" />
        </div>

        <div className="pt-4 border-t border-border/50">
          <p className="text-xs text-muted-foreground">
            If you believe this is a mistake, please contact support.
          </p>
        </div>
      </div>
    </div>
  );
};
export default NotFound;
